export const MODAL_TYPE = {
  MODAL_CENTER: 'central_draw',
  MODAL_SIDE: 'side_draw',
};

export const SIDE_DRAW_MODAL_TYPE = {
  BASE: 'base',
  LOYALTY_PROGRAM: 'loyalty_program',
};
